/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [获取授权链接↗](https://yapi.fenxianglife.com/project/379/interface/api/44680) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `GET /wechat/cp/authUrl`
 * @更新时间 `2024-01-11 15:33:15`
 */
export const feimaChatWechatCpAuthUrl = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWechatCpAuthUrlRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWechatCpAuthUrlResponse, OT>>(
    '/wechat/cp/authUrl',
    'GET',
    data,
    options
  );

/**
 * 接口 [js签名参数↗](https://yapi.fenxianglife.com/project/379/interface/api/44686) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `GET /wechat/cp/js/sign`
 * @更新时间 `2023-11-01 14:35:12`
 */
export const feimaChatWechatCpJsSign = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWechatCpJsSignRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWechatCpJsSignResponse, OT>>(
    '/wechat/cp/js/sign',
    'GET',
    data,
    options
  );

/**
 * 接口 [登录授权↗](https://yapi.fenxianglife.com/project/379/interface/api/44692) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /user/login/cp`
 * @更新时间 `2023-11-01 16:15:47`
 */
export const feimaChatUserLoginCp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginCpRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserLoginCpResponse, OT>>(
    '/user/login/cp',
    'POST',
    data,
    options
  );

/**
 * 接口 [agentJs签名参数↗](https://yapi.fenxianglife.com/project/379/interface/api/44758) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `GET /wechat/cp/js/sign/agent`
 * @更新时间 `2023-11-01 15:04:04`
 */
export const feimaChatWechatCpJsSignAgent = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWechatCpJsSignAgentRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWechatCpJsSignAgentResponse, OT>
  >('/wechat/cp/js/sign/agent', 'GET', data, options);

/**
 * 接口 [websocket对话同步↗](https://yapi.fenxianglife.com/project/379/interface/api/44830) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `GET /chat/relay`
 * @更新时间 `2023-10-16 10:24:16`
 */
export const feimaChatChatRelay = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatChatRelayRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatChatRelayResponse, OT>>(
    '/chat/relay',
    'GET',
    data,
    options
  );

/**
 * 接口 [获取整体授权二维码url↗](https://yapi.fenxianglife.com/project/379/interface/api/45394) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `GET /enterprise/workWx/generateAuthQrcodeUrl`
 * @更新时间 `2023-11-06 16:38:18`
 */
export const feimaChatEnterpriseWorkWxGenerateAuthQrcodeUrl = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxGenerateAuthQrcodeUrlRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxGenerateAuthQrcodeUrlResponse,
      OT
    >
  >(
    '/enterprise/workWx/generateAuthQrcodeUrl',
    'GET',
    data,
    options
  );

/**
 * 接口 [企微侧边栏匹配客户↗](https://yapi.fenxianglife.com/project/379/interface/api/45484) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /enterprise/workWx/matchCustomer`
 * @更新时间 `2023-11-07 19:12:06`
 */
export const feimaChatEnterpriseWorkWxMatchCustomer = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxMatchCustomerRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxMatchCustomerResponse,
      OT
    >
  >('/enterprise/workWx/matchCustomer', 'POST', data, options);

/**
 * 接口 [客户id绑定↗](https://yapi.fenxianglife.com/project/379/interface/api/45508) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /enterprise/workWx/bindCustomer`
 * @更新时间 `2023-11-06 16:38:41`
 */
export const feimaChatEnterpriseWorkWxBindCustomer = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxBindCustomerRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxBindCustomerResponse,
      OT
    >
  >('/enterprise/workWx/bindCustomer', 'POST', data, options);

/**
 * 接口 [检查是否设置授权权限↗](https://yapi.fenxianglife.com/project/379/interface/api/45790) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /enterprise/workWx/checkAgentPermissions`
 * @更新时间 `2023-11-06 16:38:46`
 */
export const feimaChatEnterpriseWorkWxCheckAgentPermissions = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxCheckAgentPermissionsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxCheckAgentPermissionsResponse,
      OT
    >
  >(
    '/enterprise/workWx/checkAgentPermissions',
    'POST',
    data,
    options
  );

/**
 * 接口 [检查应用可见范围↗](https://yapi.fenxianglife.com/project/379/interface/api/45796) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /enterprise/workWx/checkAgentVisibility`
 * @更新时间 `2023-11-06 16:38:52`
 */
export const feimaChatEnterpriseWorkWxCheckAgentVisibility = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxCheckAgentVisibilityRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxCheckAgentVisibilityResponse,
      OT
    >
  >(
    '/enterprise/workWx/checkAgentVisibility',
    'POST',
    data,
    options
  );

/**
 * 接口 [获取当前授权进度↗](https://yapi.fenxianglife.com/project/379/interface/api/45802) 的 **请求函数**
 *
 * @分类 [企业微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10369)
 * @请求头 `POST /enterprise/workWx/authProgress`
 * @更新时间 `2023-11-06 16:38:59`
 */
export const feimaChatEnterpriseWorkWxAuthProgress = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseWorkWxAuthProgressRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseWorkWxAuthProgressResponse,
      OT
    >
  >('/enterprise/workWx/authProgress', 'POST', data, options);

/**
 * 接口 [主体切换列表↗](https://yapi.fenxianglife.com/project/379/interface/api/45094) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `GET /enterprise/switch/list`
 * @更新时间 `2024-01-17 16:53:57`
 */
export const feimaChatEnterpriseSwitchList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatEnterpriseSwitchListRequest>,
  options?: OT
) => {
  // 遮蔽
  return Promise.resolve({
    code: "0",
    data: {
      list: [],
      remainPersonalAuthCount: 0,
      remainFullAuthCount: 0,
    },
    message: '成功',
  } as API.FeimaChatEnterpriseSwitchListResponse);
  // return request<
  //   ToolTypes.GetResponseType<API.FeimaChatEnterpriseSwitchListResponse, OT>
  // >('/enterprise/switch/list', 'GET', data, options);
}
  

/**
 * 接口 [切换主体↗](https://yapi.fenxianglife.com/project/379/interface/api/45100) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `POST /enterprise/switch`
 * @更新时间 `2023-10-23 17:36:30`
 */
export const feimaChatEnterpriseSwitch = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseSwitchRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatEnterpriseSwitchResponse, OT>>(
    '/enterprise/switch',
    'POST',
    data,
    options
  );

/**
 * 接口 [创建企业主体↗](https://yapi.fenxianglife.com/project/379/interface/api/45106) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `POST /enterprise/create`
 * @更新时间 `2023-11-06 15:06:18`
 */
export const feimaChatEnterpriseCreate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseCreateRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatEnterpriseCreateResponse, OT>>(
    '/enterprise/create',
    'POST',
    data,
    options
  );

/**
 * 接口 [成员入驻↗](https://yapi.fenxianglife.com/project/379/interface/api/45136) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `POST /enterprise/member/bind`
 * @更新时间 `2023-10-26 19:18:17`
 */
export const feimaChatEnterpriseMemberBind = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseMemberBindRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatEnterpriseMemberBindResponse, OT>
  >('/enterprise/member/bind', 'POST', data, options);

/**
 * 接口 [查询当前用户是否与企业绑定↗](https://yapi.fenxianglife.com/project/379/interface/api/45220) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `POST /enterprise/member/bind/query`
 * @更新时间 `2023-10-26 19:18:30`
 */
export const feimaChatEnterpriseMemberBindQuery = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseMemberBindQueryRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseMemberBindQueryResponse,
      OT
    >
  >('/enterprise/member/bind/query', 'POST', data, options);

/**
 * 接口 [获取AI辅助配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46606) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `GET /enterprise/aiAssist/config`
 * @更新时间 `2023-12-11 10:38:58`
 */
export const feimaChatEnterpriseAiAssistConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatEnterpriseAiAssistConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatEnterpriseAiAssistConfigResponse, OT>
  >('/enterprise/aiAssist/config', 'GET', data, options);

/**
 * 接口 [修改AI辅助配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46612) 的 **请求函数**
 *
 * @分类 [企业主体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10397)
 * @请求头 `POST /enterprise/aiAssist/config/edit`
 * @更新时间 `2023-12-11 10:39:07`
 */
export const feimaChatEnterpriseAiAssistConfigEdit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatEnterpriseAiAssistConfigEditRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatEnterpriseAiAssistConfigEditResponse,
      OT
    >
  >('/enterprise/aiAssist/config/edit', 'POST', data, options);

/* prettier-ignore-end */
